import React from 'react';
import QueryClauseTableRows from './QueryClauseTableRows';

const QueryClausesTableRows = ({
  code,
  category,
  canEdit,
  isEditing,
  clauses,
  validationErrors,
  queryUUID,
}) => (
  clauses.filter((c) => !c.isNew).map((clause) => (
    <QueryClauseTableRows
      key={`query_clause_table_row_${clause.uuid}`}
      category={category}
      code={code}
      clause={clause}
      queryUUID={queryUUID}
      canEdit={canEdit}
      isEditing={isEditing}
      firstClause={clause.name === clauses[0].name}
      validationErrors={validationErrors}
    />
  ))
);

export default QueryClausesTableRows;
